interface CreatePlansPageUrlOptions {
  hash?: 'features-list'
}

/**
 * Creates a url to the /pricing page.
 *
 * This page has been moved to the www webflow site and needs to be an external navigation.
 */
export function createPlansPageUrl(options: CreatePlansPageUrlOptions = {}): URL {
  // Can be expanded in the future to define query params or to dynamically pull
  // the domain, see `createUpgradePageUrlObject` for another example
  const url = new URL('https://www.flowcode.com/pricing')
  if (options.hash) url.hash = options.hash
  return url
}
